<template>
	<div id='m_zmyy'>
		<div class="g-ypxx">
			<p>
				<span class="ypxx-left">角色名称</span>
				<span class="ypxx-right"><input v-model="role_name" type="text" placeholder="请输入角色名称"></span>
				<div class=" clearfix"></div>
			</p>
			<p>
				<span class="ypxx-left">角色类型</span>
				<span class="ypxx-right">
					<RadioGroup v-model="nature">
						<Radio label="1">男演员</Radio>
						<Radio label="2">女演员</Radio>
						<Radio label="3">老人演员</Radio>
						<Radio label="4">儿童演员</Radio>
						<Radio label="5">跟组演员</Radio>
						<Radio label="6">群众演员</Radio>
						<Radio label="7">特约演员</Radio>
						<Radio label="8">特技演员</Radio>
						<Radio label="9">特型演员</Radio>
					</RadioGroup>
				</span>
				<div class=" clearfix"></div>
			</p>
			<p>
				<span class="ypxx-left">角色简介</span>
				<span class="ypxx-right">
					<textarea v-model="synopsis" class="g-wd-txt" placeholder="限300字以内"></textarea>
				</span>
				<div class=" clearfix"></div>
			</p>
			<center><input @click="ypxx" type="button" class="g-btn" value="确认提交"></center>
		</div>
	</div>
</template>

<script>
	import Axios from 'axios'
	import storage from '../../../storage/storage.js'

	export default {
		props:[
			'role_name',
			// 'nature',
			'synopsis',
		],
		data() {
			return {
// 				role_name: '',
				nature: storage.get('m_nature'),
// 				synopsis: '',
				uid: '',
				Re:true
			}
		},
		methods: {
			test_y(){
				
				this.Re = false
				this.$nextTick(()=>{
					this.Re = true
				})
				
			},
			ypxx() {
				var api = 'https://api.yopoo.cn/api/centre/updaterecruit'
				let infor = {
						role_name: this.role_name,
						nature: this.nature,
						synopsis: this.synopsis,
						id: storage.get('m_zmyy_id')//指定条数id
				}
				Axios.post(api, infor).then((res) => {
					// console.log(res.data)
					if (res.data.code == '200') {

						this.$message({ //提示发送验证码成功信息
							message: res.data.msg,
							type: 'success',
							center: true
						});
						storage.del('m_zmyy_id')
						setTimeout(() => {
							location.reload()
						}, 1000);
						
					}
					if (res.data.code == '202') {
						this.$message({ //提示发送验证码成功信息
							message: res.data.msg,
							type: 'error',
							center: true

						});
					}

				})

			}
		},
		mounted(){
			this.test_y()
		}
		
		
	}
</script>


<style>

</style>



// WEBPACK FOOTER //
// src/components/group_admin/group_modify/M_Zmyy.vue